module.exports = __webpack_public_path__ + "img/outofstock1.2a205298.png";